import axios from 'axios';

const request = {
  setActionId: (actionId) => {
    let action = actionId;
    if (actionId) {
      const elements = actionId.split('#');
      if (elements.length === 2) {
        [, action] = elements;
      }
    }

    axios.defaults.headers.common['Ftech-Action-Id'] = action;
  },
};

export const axiosMiddleware = () => (next) => (action) => {
  request.setActionId(action.type);
  next(action);
};
